import KPIPanelPeriodControl from "connected-components/kpi/components/panel-period-control"

export default function PerformanceHeader() {
  return (
    <KPIPanelPeriodControl />
  )
}
